import React from 'react';

const WordpressIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 24 24">
        <path
            fill={color}
            d="M3.421 12a8.58 8.58 0 0 0 4.835 7.72L4.164 8.508A8.546 8.546 0 0 0 3.421 12ZM17.791 11.567c0-1.06-.38-1.795-.707-2.366-.435-.707-.843-1.305-.843-2.012 0-.788.599-1.522 1.441-1.522.038 0 .074.004.111.006A8.547 8.547 0 0 0 12 3.421a8.568 8.568 0 0 0-7.168 3.867c.202.006.391.01.553.01.897 0 2.286-.108 2.286-.108.462-.028.517.652.055.706 0 0-.465.055-.982.082l3.124 9.292 1.877-5.63-1.336-3.662c-.462-.027-.9-.082-.9-.082-.462-.027-.408-.734.054-.707 0 0 1.417.11 2.26.11.897 0 2.286-.11 2.286-.11.463-.027.517.652.055.707 0 0-.466.055-.982.082l3.1 9.221.856-2.859c.371-1.187.653-2.039.653-2.773Z"
        />
        <path
            fill={color}
            d="m12.15 12.75-2.573 7.48a8.579 8.579 0 0 0 5.272-.137.756.756 0 0 1-.061-.119L12.15 12.75ZM19.527 7.884c.037.273.058.567.058.882 0 .87-.162 1.85-.652 3.073l-2.62 7.576A8.575 8.575 0 0 0 20.578 12c0-1.492-.38-2.894-1.05-4.116Z"
        />
        <path
            fill={color}
            d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.515 2 12 2Zm0 19.542c-5.261 0-9.541-4.28-9.541-9.542 0-5.261 4.28-9.541 9.541-9.541s9.541 4.28 9.541 9.54c0 5.262-4.28 9.543-9.54 9.543Z"
        />
    </svg>
);

export default WordpressIcon;
